import React from "react";
import "./HowItWorksSection.scss";
import { Button, Carousel } from "antd";
import Slider from "react-slick"
import { Card, Layout, Row, Col } from "antd";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { CALENDLY_LINK, PORTAL_BASE_URL } from "../../env";
import { trackCta } from "../../analytics";
const { Content } = Layout;

const HowItWorksSection = () => {
  return (
    <>
      <WebVersion />
      <MobileVersion />
    </>
  );
};

const steps = [
  {
    number: 1,
    title: "Add your product and inspiration image",
    description: "Upload an image of your product with an inspiration image and/or a simple prompt.",
    image: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/ai_step_1.png",
    alt: "Place this garland over a fireplace mantle like in the inspiration photo"
  },
  {
    number: 2,
    title: "Generate unlimited quality, on-brand images",
    description: "Choose from multiple images across the best foundational image models for your product.",
    image: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/ai_step_2.png",
    alt: "Scene generation interface showing room setup"
  },
  {
    number: 3,
    title: "Easily edit your image to match your brand guidelines",
    description: "Add props, erase objects, change scale, and fine-tune lighting to match your brand guidelines. ",
    image: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/ai_step_3.png",
    alt: "Image editing interface showing creative tools"
  }
];


const WebVersion = () => {
  const utm_source = localStorage.getItem('utm_source') || null;
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_how_it_works&utm_source=${utm_source}`;

  return (
    <Content className="d-none d-lg-block">
      <Row className="container-fluid how-it-works-container-2">
        <Col span={24} className="justify-space-between mb-40">
          <h1 className=" manrope f-38 w-600 black-085 lh-46 mb-0">Creating AI images is simple</h1>
          <Button onClick={() => {
            trackCta('free_trial_click', {
              section: 'how_it_works',
              placement: 'desktop',
              button: 'get_started_for_free',
            });
            window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`, "_blank")
          }}
            className={`manrope f-16 w-700 lh-24 blue-button`}>
            Get started for free
          </Button>
        </Col>

        <Col className="user-card-container">
          {steps.map((card, index) => (
            <div className="card-wrapper">
              <Card
                className="user-card"
                cover={
                  <div className="position-relative">
                    <img className="cover-image-ai" alt={card.alt} src={card.image} />
                  </div>
                }
              >
                <div className="column">
                  <div className="d-flex align-items-center">
                    <div className="manrope f-14 w-700 lh-22 card-number">{index + 1}</div>
                    <h2 className="manrope f-20 w-700 black-085 lh-28 mb-16 j-sb-a-start">
                      {card.title}
                    </h2>
                  </div>
                  <p className="manrope f-16 w-500 black-085 lh-22">
                    {card.description}
                  </p>
                </div>
              </Card>
            </div>
          ))}
        </Col>
        <Col span={24} className="justify-in-center mt-5 text-center">
          <span className="manrope f-16 black-085 lh-24 w-700">
            Want to see how our platform works in depth?{" "}
            <a className="manrope blue" href={CALENDLY_LINK} target="_blank" onClick={() => {
              trackCta('schedule_demo_click', {
                section: 'how_it_works',
                placement: 'desktop',
                button: 'schedule_a_demo',
              });
            }}>
              Schedule a demo
            </a>
          </span>
        </Col>

      </Row>
    </Content>
  );
};

const MobileVersion = () => {
  const settings = {
    autoplay: false,
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1.07,
    slidesToScroll: 1,
    vertical: false,
    customPaging: i => (
      <div className="custom-dot">
        {/* &ndash;  This is the dash */}
      </div>
    ),
  };
  const utm_source = localStorage.getItem('utm_source') || null;
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_how_it_works&utm_source=${utm_source}`;

  return (
    <Content className="d-lg-none">
      <Row className="container-fluid justify-in-start how-it-works-container-2">
        <Col span={24} className="justify-in-start text-left pdlr-16">
          <p className="manrope f-30 lh-40 w-600 black-085 mb-32">How it Works</p>
        </Col>
        <Col span={24} className="mb-32 pdl-12">
          <Slider {...settings} className="how-it-works-slider">
            {steps.map((card, index) => (
              <div className={`card-radius-pading ${index == 0 ? `first` : ``}`} key={index}>
                <Card
                  className="user-card box"
                  style={{ paddingRight: '0px', paddingLeft: 0, marginRight: '0px' }}
                  cover={
                    <div className="position-relative">
                      <img className="cover-image-ai" alt={card.alt} src={card.image} />
                    </div>
                  }
                >
                  <div className="column">
                    <div className="d-flex align-items-center">
                      <div className="manrope f-14 lh-22 w-700 card-number">{index + 1}</div>
                      <h2 className="manrope f-20 black-085 w-700 mb-8">
                        {card.title}
                      </h2>
                    </div>
                    <p className="manrope f-14 w-500 black-085 mb-0 lh-22">
                      {card.description}
                    </p>
                  </div>
                </Card>
              </div>
            ))}
          </Slider>
        </Col>
        <Col span={24} className="pdlr-16">
          <Button block onClick={() => {
            trackCta('free_trial_click', {
              section: 'how_it_works',
              placement: 'mobile',
              button: 'get_started_for_free',
            });
            window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`, "_blank")
          }}
            className={`manrope f-16 w-700 lh-24 blue-button mb-24 w-100 centerCarousel`}>
            Get started for free
          </Button>

          <div className="mt-3 text-center mb-32">
            <span className="manrope f-16 black-085 ws-6 w-700">
              Want to see how our platform works in depth?{" "}
              <a className="manrope blue" href={CALENDLY_LINK} target="_blank" onClick={() => {
                trackCta('schedule_demo_click', {
                  section: 'how_it_works',
                  placement: 'mobile',
                  button: 'schedule_a_demo',
                });
              }}>
                Schedule a demo
              </a>
            </span>
          </div>
        </Col>
      </Row>
    </Content>
  );
};
export default HowItWorksSection;
